module.exports = {"130681001":"双塔街道","130681002":"桃园街道","130681003":"清凉寺街道","130681100":"松林店镇","130681101":"码头镇","130681102":"东城坊镇","130681103":"高官庄镇","130681104":"东仙坡镇","130681105":"百尺竿镇","130681106":"义和庄镇","130681107":"刁窝镇","130681108":"林家屯镇","130681109":"豆庄镇","130681204":"孙庄乡","130681400":"高新技术产业开发区管理委员会","130681401":"京南经济开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130681.json
// module id = 174
// module chunks = 0